(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
